import type { GameConfig } from '../../shared/config';
import type { PlayerView } from '../../shared/protocol';
import { rulesLabel } from '../content/modes';

export interface RankedTotal {
  id: string;
  name: string;
  avatar: string;
  total: number;
}

/** Single-line room configuration summary for the lobby Stats tab. */
export function describeRoomConfig(config: GameConfig): string {
  return `${config.boardSize}×${config.boardSize} · ${config.roundDuration}s · ${config.minWordLength}–${config.maxWordLength} letters · ${config.maxPlayers} seats · ${rulesLabel(config)}`;
}

/** Room running totals ordered highest first; ties keep roster order. */
export function rankRoomTotals(players: readonly Readonly<PlayerView>[]): RankedTotal[] {
  return players
    .map((player) => ({ id: player.id, name: player.name, avatar: player.avatar, total: player.total }))
    .sort((a, b) => b.total - a.total);
}
